import { resetSearchTrips, searchTrips } from "functions/redux/listing/action";
import { RootStore } from "functions/redux/store";
import { FC, useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { useHistory, useLocation } from "react-router";
import NcImage from "shared/NcImage/NcImage";
import noData from "../../images/no_data.png";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import NewTripCardRender from "./NewTripCard";
import Loader from "react-loader-spinner";
import NcDropDown, { NcDropDownItem } from "shared/NcDropDown/NcDropDown";
import { getCountries, getHomeCountries } from "functions/redux/country/action";

const SearchCards: FC<{ country?: any }> = ({ country }) => {
    const { listing, user } = useSelector((state: RootStore) => state);
    const dispatch = useDispatch();
    const { countriesReducer } = useSelector((state: RootStore) => state);

    const history = useHistory();
    const location = useLocation();
    const search = location.search;

    const isOpenParam = new URLSearchParams(search).get("openTrip");
    const codeParam = new URLSearchParams(search).get("code");
    const countryNameParam = new URLSearchParams(search).get("country");
    const pageParam = new URLSearchParams(search).get("page");
    const keywordParam = new URLSearchParams(search).get("keyword");

    const [isLoadMore, setIsLoadMore] = useState(false);

    // Active tab: null for All Trip, 1 for Open Trip, 0 for Private Trip
    const tabActive = isOpenParam !== null && isOpenParam !== undefined && isOpenParam !== "null" && isOpenParam !== ""
        ? parseInt(isOpenParam, 10)
        : null;

    const currentCountryName = countryNameParam || country?.country || "Pilih Negara";

    useEffect(() => {
        if (countriesReducer.homeCountries == null) {
            dispatch(getHomeCountries());
        }
        if (countriesReducer.countries == null) {
            dispatch(getCountries());
        }
    }, [countriesReducer.homeCountries, countriesReducer.countries, dispatch]);

    useEffect(() => {
        dispatch(resetSearchTrips());
        const keyword = keywordParam && keywordParam !== "" ? keywordParam : "any";
        dispatch(
            searchTrips(
                keyword,
                user.credential,
                isOpenParam,
                codeParam,
                pageParam ?? "1"
            )
        );
    }, [dispatch, codeParam, isOpenParam, keywordParam, pageParam, user.credential]);

    const comboChange = (val: number | null) => {
        const params = new URLSearchParams(location.search);
        if (val === null) {
            params.delete("openTrip");
        } else {
            params.set("openTrip", val.toString());
        }
        params.delete("page");
        const searchStr = params.toString();
        history.replace(`${location.pathname}${searchStr ? `?${searchStr}` : ""}`);
    };

    const handleSelectCountry = (item: NcDropDownItem) => {
        const params = new URLSearchParams(location.search);
        if (item.id) {
            params.set("code", item.id);
            params.set("country", item.name);
        } else {
            params.delete("code");
            params.delete("country");
        }
        params.delete("page");
        const searchStr = params.toString();
        history.replace(`/country-trips${searchStr ? `?${searchStr}` : ""}`);
    };

    let selectCountry: NcDropDownItem[] = [
        { id: "", name: "Semua Negara", icon: "" }
    ];
    const rawCountries = countriesReducer.homeCountries || countriesReducer.countries;

    if (Array.isArray(rawCountries) && rawCountries.length > 0) {
        const countryItems: NcDropDownItem[] = rawCountries
            .map((value: any) => {
                const rawitemData = Array.isArray(value) ? value[0] : value;

                if (!rawitemData) return null;
                const itemData = rawitemData[0];
                const id = itemData.countryCode || itemData.country_code || itemData.code || itemData.id || itemData.name || "";
                const name = itemData.name || itemData.countryName || itemData.label || "";
                if (!id || !name) return null;
                return {
                    id: String(id),
                    name: String(name),
                    icon: "",
                };
            })
            .filter((item): item is NcDropDownItem => item !== null);


        const seen = new Set<string>();
        const uniqueCountries: NcDropDownItem[] = [];
        for (const c of countryItems) {
            if (!seen.has(c.id)) {
                seen.add(c.id);
                uniqueCountries.push(c);
            }
        }
        selectCountry = [...selectCountry, ...uniqueCountries];
    }

    const loadMore = async () => {
        if (!listing.searchedTrips || isLoadMore) return;
        const currentPage = parseInt(listing.searchedTrips?.page || "1", 10);
        setIsLoadMore(true);
        const keyword = keywordParam && keywordParam !== "" ? keywordParam : "any";
        await dispatch(
            searchTrips(
                keyword,
                user.credential,
                isOpenParam,
                codeParam,
                (currentPage + 1).toString()
            )
        );
        setIsLoadMore(false);
    };

    return (
        <div className={`nc-SectionGridFilterCard ${country === undefined ? 'py-8 md:py-32' : 'py-7 lg:py-9'}`}>
            {country !== undefined && country.recent === undefined && (
                <div className="flex flex-col md:flex-row md:justify-between md:items-center relative mb-4 p-4 rounded-xl bg-white dark:bg-neutral-900 shadow-sm">
                    <div className="flex items-center">
                        <NcDropDown
                            title="Select Country"
                            className="focus:outline-none"
                            panelMenusClass="origin-top-left left-0 max-h-60 overflow-y-auto"
                            data={selectCountry}
                            onClick={handleSelectCountry}
                            renderTrigger={() => (
                                <div
                                    className="flex items-center space-x-2 text-xl font-medium capitalize text-black dark:text-white hover:text-primary-6000 transition-colors py-1 px-2 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-800 cursor-pointer"
                                >
                                    <span>{currentCountryName}</span>
                                    <i className="las la-angle-down text-lg"></i>
                                </div>
                            )}
                        />
                    </div>

                    <div className="flex flex-row mt-4 md:mt-0 space-x-2">
                        <button
                            type="button"
                            onClick={() => comboChange(null)}
                            className={`flex-shrink-0 block !leading-none font-medium px-3 py-2 md:px-5 md:py-2.5 text-xs md:text-sm capitalize rounded-full focus:outline-none transition-colors 
                            ${tabActive === null
                                    ? "bg-secondary-900 text-secondary-50"
                                    : "text-neutral-500 dark:text-neutral-400 hover:text-neutral-900 hover:bg-neutral-100 dark:hover:bg-neutral-800"
                                }`}
                        >
                            All Trip
                        </button>
                        <button
                            type="button"
                            onClick={() => comboChange(1)}
                            className={`flex-shrink-0 block !leading-none font-medium px-3 py-2 md:px-5 md:py-2.5 text-xs md:text-sm capitalize rounded-full focus:outline-none transition-colors 
                            ${tabActive === 1
                                    ? "bg-secondary-900 text-secondary-50"
                                    : "text-neutral-500 dark:text-neutral-400 hover:text-neutral-900 hover:bg-neutral-100 dark:hover:bg-neutral-800"
                                }`}
                        >
                            Open Trip
                        </button>
                        <button
                            type="button"
                            onClick={() => comboChange(0)}
                            className={`flex-shrink-0 block !leading-none font-medium px-3 py-2 md:px-5 md:py-2.5 text-xs md:text-sm capitalize rounded-full focus:outline-none transition-colors 
                            ${tabActive === 0
                                    ? "bg-secondary-900 text-secondary-50"
                                    : "text-neutral-500 dark:text-neutral-400 hover:text-neutral-900 hover:bg-neutral-100 dark:hover:bg-neutral-800"
                                }`}
                        >
                            Private Trip
                        </button>
                    </div>
                </div>
            )}
            {country !== undefined && country.recent && (
                <div className="flex flex-row justify-between items-center relative mb-4 p-4 rounded-xl bg-white dark:bg-neutral-900 shadow-sm">
                    <h2 className="sm:text-md md:text-xl font-medium capitalize text-black dark:text-white">
                        Recent Open Trips
                    </h2>
                </div>
            )}
            {listing.searchedTrips != null && listing.searchedTrips.data?.length > 0 ? (
                <div className="w-full">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        {listing.searchedTrips.data.map((item: any, idx: number) => (
                            <NewTripCardRender key={item.id || item._id || item.slug || idx} item={item} />
                        ))}
                    </div>
                    {listing.searchedTrips.last === false && (
                        <div className="flex mt-4 md:mt-8 flex-row justify-center items-center w-full">
                            <ButtonSecondary onClick={loadMore} className="w-full md:w-auto" disabled={isLoadMore}>
                                {isLoadMore ? (
                                    <Loader
                                        type="Circles"
                                        color="#d24e29"
                                        height={25}
                                        width={25}
                                    />
                                ) : (
                                    <span className="text-md font-regular sm:my-2">
                                        Muat lebih banyak
                                    </span>
                                )}
                            </ButtonSecondary>
                        </div>
                    )}
                </div>
            ) : listing.searchedTrips != null ? (
                <div className="flex flex-col items-center bg-white dark:bg-neutral-900 rounded-lg p-8 space-y-8 w-full relative mt-8">
                    <NcImage src={noData} className="h-32 md:h-60" />
                    <ButtonPrimary className="py-2 md:py-3" onClick={() => history.goBack()}>
                        Go Back
                    </ButtonPrimary>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 relative">
                    <Skeleton height={350} className="rounded-lg w-full" />
                    <Skeleton height={350} className="rounded-lg w-full" />
                    <Skeleton height={350} className="rounded-lg w-full" />
                    <Skeleton height={350} className="rounded-lg w-full" />
                    <Skeleton height={350} className="rounded-lg w-full" />
                    <Skeleton height={350} className="rounded-lg w-full" />
                </div>
            )}
        </div>
    );
};

export default SearchCards;